import React, { useMemo } from 'react';
import PriceModel from '../../Types/PriceModel';
import { translate } from '../../Services/translation';

interface ProductPageProductPriceProps {
  priceModel: PriceModel;
  showUnit?: boolean;
  itemPackageSize?: number;
}
const ProductPageProductPrice = ({
  priceModel,
  showUnit = true,
  itemPackageSize = 1,
}: ProductPageProductPriceProps) => {
  const tierPriceBoxes = useMemo(() => {
    let index = priceModel.tierPrices.findIndex(
      (f) => f.minimumQuantity == itemPackageSize
    );

    if (index > -1 && itemPackageSize > 1) {
      return priceModel.tierPrices[index];
    } else {
      return undefined;
    }
  }, [itemPackageSize, priceModel]);

  return (
    <div className="flex flex-col py-0.5">
      {priceModel.formattedCampaignPrice ? (
        <div className="mb-2 text-xl font-normal leading-none text-campaign">
          {priceModel.formattedCampaignPrice}{' '}
          {showUnit && priceModel.price?.unitOfMeasurementTitle && (
            <UnitOfMeasurment
              unit={priceModel.price?.unitOfMeasurementTitle}
            />
          )}
          <span className="ml-2 text-md font-normal leading-none text-gray-500 line-through">
            {priceModel.formattedPrice}
          </span>
        </div>
      ) : (
        priceModel.formattedPrice && (
          <>
            <div className="flex text-xl font-normal leading-none">
              {priceModel.formattedPrice}
              {showUnit && priceModel.price?.unitOfMeasurementTitle && (
                <UnitOfMeasurment
                  unit={priceModel.price?.unitOfMeasurementTitle}
                />
              )}
            </div>
            <div className="flex text-xl font-normal leading-none">
              {showUnit && tierPriceBoxes && (
                <TierPrice
                  currencySymbol={priceModel.currency.symbol}
                  price={tierPriceBoxes.price}
                  unit={priceModel.price?.unitOfMeasurementTitle}
                />
              )}
            </div>
          </>
        )
      )}
    </div>
  );
};

const UnitOfMeasurment = ({ unit }: { unit: string }) => (
  <span className="ml-0.5 self-end text-md font-light leading-none text-gray-500">
    {` / ${unit?.toLowerCase()}`}
  </span>
);

const TierPrice = ({
  currencySymbol,
  price,
  unit,
}: {
  currencySymbol: string;
  price: number;
  unit?: string;
}) => {
  return (
    <span className="mt-2 self-end text-right text-sm font-light leading-none text-gray-500">
      {`${price} ${currencySymbol} / ${unit?.toLowerCase()} ${translate(
        'product-page.tier-price.box-price'
      )}`}
    </span>
  );
};

export default ProductPageProductPrice;
